module.exports = __webpack_public_path__ + "thank-you-step-bg.f59fa56.png";